var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavAccesosWhite = function SvgNavAccesosWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_accesos_white_svg__Capa_2",
    viewBox: "0 0 33.94 33.94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_accesos_white_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.66 10.71h6.62v1.5h-6.62z",
    transform: "rotate(-81.01 16.965 11.465)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.94h6.62v1.5H18.5z",
    transform: "rotate(-81.01 21.816 9.686)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.62 7.16h6.62v1.5h-6.62z",
    transform: "rotate(-81.01 26.934 7.902)",
    fill: "#19d3c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.25 32.57H15.34V16.04q0-.15-.06-.27l15.07-5.23c.88-.3 1.58-.93 1.98-1.76s.46-1.78.15-2.65l-.09-.26a3.474 3.474 0 0 0-4.42-2.14L15.32 8.12V5.76C15.32 2.58 12.78 0 9.65 0h-3.3C4.5 0 3 1.52 3 3.39v29.17H.69c-.38 0-.69.31-.69.69s.31.69.69.69h32.57c.38 0 .69-.31.69-.69s-.31-.69-.69-.69ZM9.59 10.31c.72 0 1.39.22 1.95.58l16.89-5.87c1.09-.38 2.29.2 2.67 1.29l.09.26c.18.53.15 1.1-.09 1.6s-.67.88-1.2 1.07l-16.94 5.88c-.5 1.38-1.82 2.38-3.37 2.38-1.98 0-3.6-1.61-3.6-3.6s1.61-3.6 3.6-3.6Zm-2.23 3.6c0-.19.03-.38.08-.56.01-.04.03-.08.04-.13.05-.16.12-.31.2-.45 0-.01.01-.03.02-.04.39-.63 1.09-1.05 1.88-1.05 1.23 0 2.23 1 2.23 2.22s-1 2.23-2.23 2.23-2.23-1-2.23-2.23Z",
    fill: "#fff"
  }))));
};
export default SvgNavAccesosWhite;